import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import Table from "../../components/table/Table";
import { fetchAllProduct } from "../../redux/features/product.features";

const PrintAllItemsReport = () => {
  let dispatch = useDispatch();

  //   useEffect(() => {
  //     dispatch(fetchAllProduct());
  //   }, [dispatch]);

  let productState = useSelector((state) => {
    return state.productReducer;
  });

  let { products } = productState;
  let componentRef = useRef();

  const allItemTableHead = [
    "Item ID",
    "title",
    "category",
    "date",
    "clarity",
    // "need_recut",
    "treat",
    "origin",
    "shape",
    "weight",
    "dimens..",
    "buy Price",
    "sell Price (L)",
    "sell Price (F)",
    "status",
  ];

  const finalRenderBody = (item, index) => (
    <tr style={{ color: "var(--txt-color)" }} key={index}>
      <td>{item.productId}</td>
      <td>{item.title}</td>
      <td>{item.category}</td>
      {/* <td>{item.description}</td> */}
      <td>{item.date}</td>
      <td>{item.clarity}</td>
      {/* <td>{item.need_recut}</td> */}
      <td>{item.treatment_type}</td>
      <td>{item.origin}</td>
      <td>{item.shape}</td>
      <td>{item.weight}</td>
      <td>{item.dimension}</td>
      <td className="text-right">
        <span>{Number(item.buyPrice).toLocaleString()}</span>{" "}
        <span style={{ width: 35 }} className="">
          {item.buyCurrency}
        </span>
      </td>
      <td className="text-right">
        <span>{Number(item.sellPriceLocal).toLocaleString()}</span>{" "}
        <span style={{ width: 35 }} className="">
          {item.sellLocalCurrency}
        </span>
      </td>
      <td className="text-right">
        <span>{Number(item.sellPriceForeigners).toLocaleString()}</span>{" "}
        <span style={{ width: 35 }} className="">
          {item.sellForeignersCurrency}
        </span>
      </td>

      {/* <td style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <p className="flex justify-end"><span>{Number(item.buyPrice).toLocaleString()}</span> <span style={{width:35}}className="">{item.buyCurrency}</span></p>

      </td>
      <td >
        <p className="flex justify-end"><span className="flex justify-end">{Number(item.sellPriceLocal).toLocaleString()}</span> <span style={{width:35}} className="">{item.sellLocalCurrency}</span></p>

      </td>

      <td >
        <p className="flex justify-end"><span>{Number(item.sellPriceForeigners).toLocaleString()}</span> <span style={{width:35}} className="">{item.sellForeignersCurrency}</span></p>
      </td> */}
      <td>{item.isSold ? "out stock" : "in stock"}</td>
    </tr>
  );

  const renderHead = (item, index) => (
    <th className="mb-2" key={index}>
      {item}
    </th>
  );

  const print = useReactToPrint({
    pageStyle: `  
    @media print{
        ::-webkit-scrollbar {
            display: none;
          }

        div{
        color: black !important;
    }    
        table{
            color: black !important;
        }
        thead {
            background-color: transparent;
        }
            
      @page {
          margin-top: 10px;
          margin-bottom: 10px;
          size: A3;
          
           }
      body{
        -webkit-print-color-adjust: exact;
          font-size:9px;
          color:#000 !important;
        
      }
      section{
      
      background-color: white;
  }
  
  h1{
      font-size: 10px;
      
  }
  p{
      font-size: 9px;
  }
  table{
    width:100%;
    font-size: 8px;
  }
  td{
    font-size: 8px;
  }
  }
    `, // remove date/time from top

    // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
    content: () => componentRef.current,
  });

  function setPageSize(cssPageSize) {
    const style = document.createElement("style");
    style.innerHTML = `@page {size: ${cssPageSize}}`;
    style.id = "page-orientation";
    document.head.appendChild(style);
  }
  const [orientation, setOrientation] = useState("landscape");
  useEffect(() => {
    setPageSize(orientation);
    return () => {
      const child = document.getElementById("page-orientation");
      child.parentNode.removeChild(child);
    };
  }, [orientation]);

  return (
    <div className="flex flex-col w-full">
      <div
        className="bg-blue-400 p-5 bx bx-printer w-3/12 cursor-pointer text-white text-center hover:bg-blue-700 hover:font-extrabold"
        onClick={() => {
          print();
        }}
      >
        Print
      </div>

      <div ref={componentRef} className="flex flex-col w-full">
        <div className="font-extrabold text-2xl flex justify-center">
          SHIMLA GEM REPORTS{" "}
        </div>
        <div className="font-extrabold text-xl flex justify-center">
          ALL ITEMS LIST - ({products.length})
        </div>
        <div className="m-2">{new Date().toDateString()}</div>
        <hr></hr>
        <Table
          //   limit="10"
          headData={allItemTableHead}
          renderHead={(item, index) => renderHead(item, index)}
          bodyData={products}
          renderBody={(item, index) => finalRenderBody(item, index)}
        ></Table>
      </div>
    </div>
  );
};

export default PrintAllItemsReport;
